import React, {useEffect, useState} from 'react';
import { createLogger } from '../utils/logging';

const logger = createLogger('MemberWebcomponent');

export const Member = (props: any) => {
    logger.debug('Component Initialized', 'Member webcomponent mounted', { props });
    const {context} = props;
    const ref = React.useRef(null);
    const [viewName, setViewName] = useState<string>('memberSearch');
    const [memberContext, setMemberContext] = React.useState(() => JSON.stringify(context));
    const priorAuthWebComponentURL = (window as any).environments?.priorAuthWebComponentURL;

    // Lazy load the web component script
    useEffect(() => {
        if (!customElements.get('member-mp')) {
            const env = (window as any).environments;
            if (env?.memberWebComponentURL) {
                const script = document.createElement('script');
                script.src = env.memberWebComponentURL;
                script.onerror = () => logger.error('Script Load Failed', 'Unable to load member webcomponent', { url: env.memberWebComponentURL });
                document.head.appendChild(script);
            }
        }
    }, []);

    useEffect(() => {
        const handleEvent = (e: any) => {
            logger.debug('Event Received', 'Member webcomponent event', { type: e.detail?.type });
            const {detail} = e;

            // eslint-disable-next-line default-case
            switch (detail.type) {
                case '[MEMBER] ROUTE': {
                    logger.info('Route Change', 'Member view navigation', {
                        viewName: detail.payload.viewName,
                        searchDetailParam: detail.payload.searchDetailParam,
                    });
                    const newContext = JSON.stringify({...context, searchDetailParam: detail.payload.searchDetailParam});
                    setMemberContext(newContext);
                    if (detail.payload.viewName) {
                        setViewName(detail.payload.viewName);
                    }
                    break;
                }
            }
        };

        const curentRef: any = ref.current;
        logger.debug('Effect Setup', 'Attaching event listener', { hasRef: !!curentRef });
        setMemberContext(JSON.stringify(context));

        if(curentRef) {
            curentRef.addEventListener('event', handleEvent);
        }
        return () => {
            curentRef.removeEventListener('event', handleEvent);
        };
    }, [context]);

    return (
        // @ts-ignore
        <member-mp 
            ref={ref}
            view={viewName}
            id="member-webcomponent"
            data-testid="member-mp"
            text="Member" context={memberContext}
            prior-auth-web-component-url={priorAuthWebComponentURL}
        />
    );
};

export default Member;
